import { ReactNode } from "react"

import { BetaBadge, MenuIcon, MenuIconStroke, MenuLabelWrapper, MenuText, RedDot, StyledNavLink } from "./styled"
import { useVerticalMenuContext } from "./VerticalMenu"

interface MenuItemProps {
  to: string
  icon: ReactNode
  label: string
  badge?: ReactNode
  iconType?: "fill" | "stroke"
  activeIconColor?: string
  beta?: boolean
}

export const MenuItem = ({ to, icon, label, badge, iconType = "fill", activeIconColor, beta }: MenuItemProps) => {
  const { isOpen, closeMobileMenu } = useVerticalMenuContext()
  const IconWrapper = iconType === "stroke" ? MenuIconStroke : MenuIcon

  const handleClick = () => {
    window.scrollTo({ top: 0 })
    closeMobileMenu()
  }

  return (
    <StyledNavLink to={to} activeClassName="active" $activeIconColor={activeIconColor} onClick={handleClick}>
      <IconWrapper>{icon}</IconWrapper>
      {beta ? (
        <MenuLabelWrapper $isOpen={isOpen}>
          <MenuText as="span" $isOpen={isOpen}>
            {label}
          </MenuText>
          <BetaBadge $isOpen={isOpen}>Beta</BetaBadge>
        </MenuLabelWrapper>
      ) : (
        <>
          <MenuText $isOpen={isOpen}>{label}</MenuText>
          {badge}
        </>
      )}
    </StyledNavLink>
  )
}

interface MenuBadgeProps {
  count?: number
}

export const MenuBadge = ({ count }: MenuBadgeProps) => {
  const { isOpen } = useVerticalMenuContext()

  if (!count) return null

  return <RedDot $isOpen={isOpen}>{count}</RedDot>
}
